import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Show } from "shared/components";
import { IncomeType } from "shared/types";
import { cx } from "shared/utils";

export const WarningRecommendation = ({
  type,
  status,
  rejectionReason = "Document requires manual review",
  className
}: {
  type?: IncomeType;
  status?: "Rejected" | "Warning" | "Accepted";
  rejectionReason?: string;
  className?: string;
}) => {
  if (status === "Rejected" || status === "Warning")
    return (
      <div
        className={cx(
          "flex items-center gap-3 p-4 rounded-lg border border-alpha-100",
          status === "Rejected" ? "bg-danger-50" : "bg-warning-50",
          className
        )}
      >
        <HugeiconsIcon
          icon={AlertCircleIcon}
          size={20}
          className={cx(
            "shrink-0",
            status === "Rejected" ? "text-danger-500" : "text-warning-500"
          )}
        />
        {type === IncomeType.OfferLetter ? (
          <p className="text-sm text-content-1000 font-medium">
            {rejectionReason}
          </p>
        ) : (
          <p className="text-sm text-content-1000 font-medium">
            {status === "Warning" &&
              "We recommend manually reviewing the document as suspicious signals were found"}

            {status === "Rejected" &&
              `Uploaded document rejected: ${rejectionReason}`}
          </p>
        )}
      </div>
    );

  return null;
};
